var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 423.721H8.828A8.829 8.829 0 0 1 0 414.893V97.101a8.829 8.829 0 0 1 8.828-8.828h161.839v335.448z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M170.67 88.277h170.67v335.45H170.67z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#73af00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 0 1 512 97.101v317.792a8.828 8.828 0 0 1-8.828 8.828zM314.959 342.595l-27.396-159.812a49.976 49.976 0 0 0-6.402-17.266L256 123.583l-25.161 41.935a49.956 49.956 0 0 0-6.402 17.266L197.04 342.597a4.997 4.997 0 0 0 4.925 5.841h44.041v39.973h19.987v-39.974h44.041a4.997 4.997 0 0 0 4.925-5.842z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNf);
export default __webpack_public_path__ + "static/media/nf.c6d8e77046e3343c5b5528119c7bacf0.svg";
export { ForwardRef as ReactComponent };